// extracted by mini-css-extract-plugin
export var infoRow = "_r9-2";
export var labelContainer = "_r9-0";
export var rightInfo = "_r9-1";